<template>
  <el-container id="ids">
    <el-header>
      <div @mousedown="mousedown">
        <div style="display: flex;align-items: center;justify-content: space-between">
          <div style="    font-size: 18px;color: #303133;">{{title}}</div>
          <div @click="closeDialog">
            <i class="el-icon-close" title="关闭" style="cursor: pointer;"></i>
          </div>
        </div>
      </div>
    </el-header>
    <counter></counter>
    <!-- <el-footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </span>
    </el-footer>-->
  </el-container>
</template>

<script>
import counter from "./inx";
export default {
  components: { counter },
  name: "Window",
  props: {
    titlex: String
  },
  data() {
    return {
      title: "计算器",
      selectElement: ""
    };
  },
  computed: {},
  methods: {
    closeDialog(e) {
      this.$emit("closeDialog", false);
    },
    mousedown(event) {
      this.selectElement = document.getElementById("ids");
      var div1 = this.selectElement;
      this.selectElement.style.cursor = "move";
      this.isDowm = true;
      var distanceX = event.clientX - this.selectElement.offsetLeft;
      var distanceY = event.clientY - this.selectElement.offsetTop;
      // alert(distanceX)
      // alert(distanceY)
      console.log("event.clientX", event.clientX);
      console.log(
        " this.selectElement.offsetLeft",
        this.selectElement.offsetLeft
      );
      //   console.log(distanceX);
      //   console.log(distanceY);
      document.onmousemove = function(ev) {
        var oevent = ev || event;
        div1.style.left = oevent.clientX - distanceX + "px";
        div1.style.top = oevent.clientY - distanceY + "px";
      };
      document.onmouseup = function() {
        document.onmousemove = null;
        document.onmouseup = null;
        div1.style.cursor = "default";
      };
    }
  }
};
</script>

<style scoped>
#ids {
  z-index: 10000000000;
  position: fixed;
  border: solid 1px #aaa;
}
.el-container {
  position: absolute;
  /* height: 500px; */
  width: 500px;
  border: 1px;
  top: 20%;
  left: 35%;

  border-radius: 2px;
  background: rgb(246, 249, 250) !important;
}

.dialog-footer {
  text-align: right;
}

.el-main {
}

.el-footer {
}

.el-header {
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/components/common/drag.vue